const PAGE_HOME = "News Home";
const PAGE_CATEGORY = "News Category";
const PAGE_ARTICLE = "News Article";
const PAGE_AUTHOR = "News Author";
const PAGE_SEARCH_RESULTS = "News Search Results";
const PAGE_TAG_RESULTS = "News Tag Results";
const PAGE_ABOUT = "News About";
const PAGE_NOT_FOUND = "Not Found";

const PREMIUM_SUB_STATUS = "Premium";
const FREE_SUB_STATUS = "Free";

const UTM_SOURCE = "utm_source";
const UTM_MEDIUM = "utm_medium";
const UTM_CAMPAIGN = "utm_campaign";
const UTM_TERM = "utm_term";
const UTM_CONTENT = "utm_content";

const REFERRING_DOMAIN = "referring_domain";

export {
  PAGE_HOME,
  PAGE_CATEGORY,
  PAGE_ARTICLE,
  PAGE_AUTHOR,
  PAGE_SEARCH_RESULTS,
  PAGE_TAG_RESULTS,
  PAGE_ABOUT,
  PAGE_NOT_FOUND,
  PREMIUM_SUB_STATUS,
  FREE_SUB_STATUS,
  UTM_SOURCE,
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  UTM_TERM,
  UTM_CONTENT,
  REFERRING_DOMAIN,
};
